import { render, staticRenderFns } from "./RsaConfigurazioneModalitaSomminsitrazioneModalEditComponent.vue?vue&type=template&id=7b5b04ba"
import script from "./RsaConfigurazioneModalitaSomminsitrazioneModalEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneModalitaSomminsitrazioneModalEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports